<div class="dash">
  <div class="hd-scope">

    <!-- Greeting row -->
    <div class="hd-greeting-row">
      <div class="hd-greeting-text">
        <h2 class="hd-greeting-title">{{ greeting }}<ng-container *ngIf="firstName">, {{ firstName }}</ng-container> <span aria-hidden="true">👋</span></h2>
        <p class="hd-greeting-sub">Here's your health overview</p>
      </div>

      <!-- Add Record (tablet / desktop). On phones it is replaced by the round "+" button at the bottom of this file.
           If your app shell already renders an Add Record button in this row, delete this block and the .hd-fab-wrap block. -->
      <div class="hd-add-wrap">
        <button type="button" class="hd-add-btn" aria-haspopup="dialog" [attr.aria-expanded]="addMenuOpen" (click)="toggleAddMenu($event)">
          <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
          <span>Add Record</span>
        </button>
      </div>
    </div>

    <!-- First row: Profile | Health Tips -->
    <div class="hd-top-row">

      <!-- Profile card -->
      <section class="hd-card hd-profile-card" aria-labelledby="hd-profile-title">
        <div class="hd-card-head">
          <span class="hd-card-icon" aria-hidden="true"><svg class="hd-i" viewBox="0 0 24 24"><rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4V3h6v1M9 4h6v2H9z"/><path d="M12 10.5v6M9 13.5h6"/></svg></span>
          <h3 class="hd-card-title" id="hd-profile-title">Profile</h3>
          <button type="button" class="hd-edit-btn" aria-label="Edit health profile" (click)="onEditHealth()">
            <img src="assets/images/health/icons/Editicon.svg" alt="" aria-hidden="true" />
            <span>Edit</span>
          </button>
        </div>

        <!-- Show spinner while loading -->
        <div *ngIf="isLoadingProfile" class="spinner" role="status" aria-label="Loading profile"></div>

        <dl class="hd-stats" *ngIf="!isLoadingProfile">
          <div class="hd-stat"><dt>Height</dt><dd>{{ profileData?.height || '—' }} {{ profileData?.height ? profileData?.heightUnit : '' }}</dd></div>
          <div class="hd-stat hd-stat--strong"><dt>Weight</dt><dd>{{ profileData?.weight || '—' }} {{ profileData?.weight ? profileData?.weigthtUnit : '' }}</dd></div>
          <div class="hd-stat"><dt>BMI</dt><dd>{{ profileData?.bmi || '—' }}<span class="hd-bmi" *ngIf="bmiLabel" [ngClass]="'hd-bmi--' + bmiKey">{{ bmiLabel }}</span></dd></div>
          <div class="hd-stat"><dt>Blood Grp</dt><dd>{{ profileData?.bloodGroup || '—' }}</dd></div>
        </dl>
      </section>

      <!-- Health Tips card: one deterministic tip per day -->
      <section class="hd-card hd-tip-card" *ngIf="dailyTip" [ngClass]="'hd-tip-card--' + dailyTip.categoryId" aria-labelledby="hd-tip-title">
        <div class="hd-card-head">
          <span class="hd-card-icon" aria-hidden="true"><i class="fas fa-lightbulb"></i></span>
          <h3 class="hd-card-title" id="hd-tip-title">Health Tips</h3>
          <span class="hd-tip-badge">{{ dailyTip.category }}</span>
        </div>
        <p class="hd-tip-text">{{ dailyTip.tip }}</p>
        <span class="hd-tip-visual" role="img"
              [attr.aria-label]="({ water: 'Water intake', exercise: 'Exercise', mindfulness: 'Mindfulness', nutrition: 'Nutrition', sleep: 'Sleep' }[dailyTip.categoryId] || 'Health') + ' health tip'"
              [ngClass]="'hd-tip-visual--' + dailyTip.categoryId"
              [style.backgroundImage]="'url(' + dailyTip.background + ')'"></span>
      </section>
    </div>

    <!-- Info cards: swipe, drag with the mouse, use the arrows, or focus a card and press the arrow keys -->
    <div class="hd-card-grid">
      <article class="hd-info" *ngFor="let card of cards; trackBy: trackCard"
               [ngClass]="'hd-info--' + card.tint" [class.is-loading]="card.status === 'loading'" [class.is-error]="card.status === 'error'" [attr.aria-busy]="card.status === 'loading'" [attr.aria-labelledby]="'hd-c-' + card.id">
        <div class="hd-info-inner">

          <header class="hd-info-head">
            <h3 class="hd-info-title" [id]="'hd-c-' + card.id">{{ card.title }}</h3>
            <div class="hd-info-actions">
              <!-- Compact "+": only shown when the card already has data (no empty state) -->
              <button type="button" class="hd-add-icon"
                      *ngIf="card.addCategory && card.slides[0]?.kind !== 'empty'"
                      [attr.aria-label]="card.addTip" [attr.title]="card.addTip"
                      [disabled]="card.status === 'loading'"
                      (click)="handlePlusClick($event, card.addCategory || '')">
                <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
              </button>
              <button type="button" class="hd-viewall" *ngIf="card.slides[0]?.kind !== 'empty'" [attr.aria-label]="'View all ' + card.title" (click)="openCard(card, $event)">
                <span class="hd-viewall-text" style="font-weight: 600 !important; font-size: calc(14 * var(--hd-u));">View all</span>
                <svg class="hd-i hd-viewall-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
              </button>
            </div>
          </header>

          <div class="hd-track" #track tabindex="0" role="group" aria-roledescription="carousel"
               [attr.aria-label]="card.title + (card.slides.length > 1 ? ' - use the left and right arrow keys to browse, Enter to open' : ' - press Enter to open')"
               [attr.data-card]="card.id"
               (scroll)="trackScroll(card, track)"
               (pointerdown)="onTrackPointerDown($event, track)"
               (keydown.arrowright)="onTrackKey($event, track, 1)"
               (keydown.arrowleft)="onTrackKey($event, track, -1)"
               (keydown.enter)="onTrackEnter($event, card, track)">

            <div class="hd-slide" [class.hd-slide--empty]="slide.kind === 'empty'" *ngFor="let slide of card.slides; let i = index; trackBy: trackSlide"
                 role="group" aria-roledescription="slide" [attr.aria-label]="(i + 1) + ' of ' + card.slides.length"
                 [attr.title]="slide.note || null"
                 (click)="onSlideActivate($event, card, slide)">
              <div class="hd-slide-main">
                <span class="hd-tile" aria-hidden="true">
                  <ng-container *ngIf="slide.kind === 'summary' || slide.kind === 'empty'">
                    <img *ngIf="!card.icon" [src]="card.image" alt="" draggable="false" />
                    <ng-container *ngIf="card.icon">
                      <ng-container [ngSwitch]="slide.icon || card.icon">
                        <svg *ngSwitchCase="'pill'" class="hd-i" viewBox="0 0 24 24"><path d="M10.5 20.5l10-10a4.95 4.95 0 0 0-7-7l-10 10a4.95 4.95 0 0 0 7 7zM8.5 8.5l7 7"/></svg>
                        <svg *ngSwitchCase="'heart'" class="hd-i" viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>
                        <svg *ngSwitchCase="'doc'" class="hd-i" viewBox="0 0 24 24"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6M8 13h8M8 17h5"/></svg>
                        <svg *ngSwitchCase="'shield'" class="hd-i" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                        <svg *ngSwitchCase="'syringe'" class="hd-i" viewBox="0 0 24 24"><path d="M18 2l4 4M17 7l3-3M19 9l-8.7 8.7a2 2 0 0 1-2.8 0L6.3 16.5a2 2 0 0 1 0-2.8L15 5M9 11l4 4M5 19l-3 3M14 4l6 6"/></svg>
                        <svg *ngSwitchCase="'warning'" class="hd-i" viewBox="0 0 24 24"><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4M12 17h.01"/></svg>
                        <svg *ngSwitchCase="'allergy'" class="hd-i" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><line x1="12" y1="9" x2="12" y2="4"/><circle cx="12" cy="3.5" r="1.2"/><line x1="14.6" y1="10.4" x2="18.6" y2="7.2"/><circle cx="19.3" cy="6.7" r="1.2"/><line x1="14.6" y1="13.6" x2="18.6" y2="16.8"/><circle cx="19.3" cy="17.3" r="1.2"/><line x1="12" y1="15" x2="12" y2="20"/><circle cx="12" cy="20.5" r="1.2"/><line x1="9.4" y1="13.6" x2="5.4" y2="16.8"/><circle cx="4.7" cy="17.3" r="1.2"/><line x1="9.4" y1="10.4" x2="5.4" y2="7.2"/><circle cx="4.7" cy="6.7" r="1.2"/></svg>
                        <svg *ngSwitchCase="'users'" class="hd-i" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5"/><path d="M2 21a7 7 0 0 1 14 0M17 4.5a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-4-6.3"/></svg>
                        <svg *ngSwitchCase="'phone'" class="hd-i" viewBox="0 0 24 24"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M12 18h.01"/></svg>
                        <svg *ngSwitchCase="'insurance'" class="hd-i hd-i--ins" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                        <!-- Vitals readings: same devices as the Add Vitals dialog, outline style -->
                        <svg *ngSwitchCase="'drop'" class="hd-i" viewBox="0 0 24 24"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>
                        <svg *ngSwitchCase="'lungs'" class="hd-i" viewBox="0 0 24 24"><path d="M12 3v7M12 10l-3 2M12 10l3 2"/><path d="M9 9.5V17a3 3 0 0 1-3 3c-1.7 0-2.5-1.2-2.5-2.8 0-3 2-7.6 4-8.6.9-.4 1.5.2 1.5.9z"/><path d="M15 9.5V17a3 3 0 0 0 3 3c1.7 0 2.5-1.2 2.5-2.8 0-3-2-7.6-4-8.6-.9-.4-1.5.2-1.5.9z"/></svg>
                        <svg *ngSwitchCase="'heartpulse'" class="hd-i" viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/><path d="M7 12h2.5l1.5-2.5 2 5 1.5-2.5H17"/></svg>
                        <svg *ngSwitchCase="'scale'" class="hd-i" viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="3"/><path d="M8 9a5 5 0 0 1 8 0"/><path d="M12 11l1.8-2.2"/></svg>
                        <svg *ngSwitchCase="'thermo'" class="hd-i" viewBox="0 0 24 24"><path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z"/></svg>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <svg *ngIf="slide.kind === 'add'" class="hd-i" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>
                </span>
                <div class="hd-slide-text">
                  <div class="hd-slide-title" (mouseenter)="tipIfTruncated($event)">{{ slide.title }}</div>
                  <div class="hd-slide-sub" (mouseenter)="tipIfTruncated($event)">{{ slide.subtitle }}</div>
                </div>
                <svg *ngIf="slide.kind !== 'empty'" class="hd-i hd-slide-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
              </div>

              <div class="hd-slide-foot hd-slide-foot--action" *ngIf="slide.kind === 'empty'; else recordFoot">
                <button type="button" class="hd-empty-action"
                        (click)="card.addCategory ? handlePlusClick($event, card.addCategory) : null"
                        [disabled]="!card.canAddRecord || card.status === 'loading'">
                  <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
                  <span>{{ slide.actionLabel }}</span>
                </button>
              </div>

              <ng-template #recordFoot>
              <div class="hd-slide-foot">
                <span class="hd-foot-label">
                  <ng-container [ngSwitch]="slide.kind === 'add' ? 'plus' : card.footIcon">
                    <svg *ngSwitchCase="'plus'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
                    <svg *ngSwitchCase="'clock'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
                    <svg *ngSwitchCase="'shield'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                    <svg *ngSwitchCase="'pulse'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12h4l3-8 4 16 3-8h4"/></svg>
                    <svg *ngSwitchCase="'doc'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6M8 13h8M8 17h5"/></svg>
                    <svg *ngSwitchCase="'calendar'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                    <svg *ngSwitchCase="'alert'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4M12 17h.01"/></svg>
                    <svg *ngSwitchCase="'users'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2 21a7 7 0 0 1 14 0M17 4.5a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-4-6.3"/></svg>
                    <svg *ngSwitchCase="'phone'" class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M12 18h.01"/></svg>
                  </ng-container>
                  <span>{{ slide.footLabel }}</span>
                </span>
                <b class="hd-foot-value" [class.hd-foot-value--danger]="slide.footTone === 'danger'" (mouseenter)="tipIfTruncated($event)">{{ slide.footValue }}</b>
              </div>
              </ng-template>
            </div>
          </div>

          <!-- Dots + arrows. A single-panel card shows one dot and hides both arrows (like the design). -->
          <div class="hd-controls">
            <button type="button" class="hd-nav hd-nav--prev" aria-label="Previous"
                    [class.is-off]="activeIndex(card) === 0" (click)="scrollSlide(track, -1)">
              <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
            </button>
            <div class="hd-dots" aria-hidden="true">
              <span class="hd-dot" *ngFor="let s of card.slides; let d = index" [class.is-active]="d === activeIndex(card)"></span>
            </div>
            <button type="button" class="hd-nav hd-nav--next" aria-label="Next"
                    [class.is-off]="activeIndex(card) === card.slides.length - 1" (click)="scrollSlide(track, 1)">
              <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
            </button>
          </div>

        </div>
      </article>
    </div>

    <!-- Health Log strip (same click handler as before) -->
    <div class="hd-log" role="button" tabindex="0"
         title="Click to view your health activity timeline"
         (click)="onHealthLogClick()"
         (keydown.enter)="onHealthLogClick()"
         (keydown.space)="onHealthLogClick(); $event.preventDefault()">
      <span class="hd-log-icon" aria-hidden="true">
        <svg class="hd-i" viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 9-9 9 9 0 0 0-6.36 2.64L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l3 3"/></svg>
      </span>
      <div class="hd-log-body">
        <span class="hd-log-title">Health Log <span class="hd-log-dot">·</span> <span class="hd-log-desc">Track your daily health activity</span><ng-container *ngIf="lastUpdated"> <span class="hd-log-dot">·</span> <span class="hd-log-updated">Last updated {{ lastUpdated }}</span></ng-container></span>
      </div>
      <button type="button" class="hd-log-btn" aria-label="View Health Log" (click)="onHealthLogClick(); $event.stopPropagation()">
        <span class="hd-log-btn-text">View Log</span>
        <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </button>
    </div>

  </div>

  <!-- Round "+" button (phones). Hidden while the care-plan overlay is open. -->
  <div class="hd-fab-wrap" *ngIf="!showCarePlan">
    <button type="button" class="hd-fab" aria-label="Add record" aria-haspopup="dialog" [attr.aria-expanded]="addMenuOpen" (click)="toggleAddMenu($event)">
      <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
    </button>
  </div>

  <!-- Add Record modal (opened with MatDialog from toggleAddMenu()). Every card calls the existing handlePlusClick() through onAddRecord(). -->
  <ng-template #addMenuTpl>
    <div class="hd-ar">
      <header class="hd-ar-head">
        <div>
          <h2 class="hd-ar-title" id="hd-ar-title">Add Record</h2>
          <p class="hd-ar-sub">Choose a record type to add</p>
        </div>
        <button type="button" class="hd-ar-close" aria-label="Close" (click)="closeAddRecord()">
          <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
      </header>
      <div class="hd-ar-grid">
        <button type="button" class="hd-ar-card" *ngFor="let item of addMenuItems" (click)="onAddRecord($event, item.category)">
          <span class="hd-ar-ico" [style.background]="item.bg" [style.color]="item.color" aria-hidden="true">
            <ng-container [ngSwitch]="item.icon">
              <svg *ngSwitchCase="'pill'" class="hd-i" viewBox="0 0 24 24"><path d="M10.5 20.5l10-10a4.95 4.95 0 0 0-7-7l-10 10a4.95 4.95 0 0 0 7 7zM8.5 8.5l7 7"/></svg>
              <svg *ngSwitchCase="'heart'" class="hd-i" viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>
              <svg *ngSwitchCase="'doc'" class="hd-i" viewBox="0 0 24 24"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6M8 13h8M8 17h5"/></svg>
              <svg *ngSwitchCase="'shield'" class="hd-i" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <svg *ngSwitchCase="'syringe'" class="hd-i" viewBox="0 0 24 24"><path d="M18 2l4 4M17 7l3-3M19 9l-8.7 8.7a2 2 0 0 1-2.8 0L6.3 16.5a2 2 0 0 1 0-2.8L15 5M9 11l4 4M5 19l-3 3M14 4l6 6"/></svg>
              <svg *ngSwitchCase="'warning'" class="hd-i" viewBox="0 0 24 24"><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4M12 17h.01"/></svg>
              <svg *ngSwitchCase="'users'" class="hd-i" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5"/><path d="M2 21a7 7 0 0 1 14 0M17 4.5a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-4-6.3"/></svg>
              <svg *ngSwitchCase="'phone'" class="hd-i" viewBox="0 0 24 24"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M12 18h.01"/></svg>
              <svg *ngSwitchCase="'insurance'" class="hd-i hd-i--ins" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <svg *ngSwitchCase="'vitalsecg'" class="hd-i" viewBox="0 0 24 24"><path style="fill:currentColor;stroke:none" d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/><path style="fill:none;stroke:currentColor;stroke-width:3.2;stroke-linecap:butt;stroke-linejoin:round" d="M1.2 12.5H7.5L9 10L11 14.5L13.5 7L15.5 15L17 11.5L18 12.5H22.8"/><path style="fill:none;stroke:#fff;stroke-width:1.5;stroke-linecap:butt;stroke-linejoin:round" d="M1.2 12.5H7.5L9 10L11 14.5L13.5 7L15.5 15L17 11.5L18 12.5H22.8"/></svg>
              <svg *ngSwitchCase="'allergy'" class="hd-i" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><line x1="12" y1="9" x2="12" y2="4"/><circle cx="12" cy="3.5" r="1.2"/><line x1="14.6" y1="10.4" x2="18.6" y2="7.2"/><circle cx="19.3" cy="6.7" r="1.2"/><line x1="14.6" y1="13.6" x2="18.6" y2="16.8"/><circle cx="19.3" cy="17.3" r="1.2"/><line x1="12" y1="15" x2="12" y2="20"/><circle cx="12" cy="20.5" r="1.2"/><line x1="9.4" y1="13.6" x2="5.4" y2="16.8"/><circle cx="4.7" cy="17.3" r="1.2"/><line x1="9.4" y1="10.4" x2="5.4" y2="7.2"/><circle cx="4.7" cy="6.7" r="1.2"/></svg>
            </ng-container>
          </span>
          <span class="hd-ar-text">
            <span class="hd-ar-name">{{ item.label }}</span>
            <span class="hd-ar-desc">{{ item.desc }}</span>
          </span>
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Samsung Health "Coming Soon" (informational only: no sign-in, no sync, no API call, no connected state).
       Opened by openComingSoon() from the Connected Health card AND from the Add Record modal. -->
  <ng-template #comingSoonTpl>
    <div class="hd-ar hd-cs">
      <header class="hd-ar-head hd-cs-head">
        <span class="hd-cs-app" aria-hidden="true">
          <svg class="hd-i" viewBox="0 0 24 24"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M12 18h.01"/></svg>
        </span>
        <h2 class="hd-ar-title" id="hd-cs-title">Connected Health</h2>
        <button type="button" class="hd-ar-close" aria-label="Close" (click)="closeComingSoon()">
          <svg class="hd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
      </header>
      <div class="hd-cs-body">
        <!-- <span class="hd-cs-clock" aria-hidden="true">
          <svg class="hd-i" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
        </span> -->
        <!-- <span class="hd-cs-badge">Coming Soon</span> -->
        <h3 class="hd-cs-heading">Samsung Health integration is coming soon!</h3>
        <p class="hd-cs-text" id="hd-cs-desc">We're working on bringing Samsung Health to VitaGist so you can sync your health data more easily. This feature isn't available yet, but we're planning to make it available in a future update.</p>
        <p class="hd-cs-hint">Stay tuned for updates.</p>
      </div>
      <div class="hd-cs-actions">
        <button type="button" class="hd-cs-btn" cdkFocusInitial (click)="closeComingSoon()">Got it</button>
      </div>
    </div>
  </ng-template>

  <!-- Logo spinner while the dashboard loads (same markup / look as the Vitals screen). Outside .hd-scope on purpose:
       that element uses container-type, which would trap a position:fixed child. -->
  <div class="hd-upload-overlay" *ngIf="pageLoader" role="status" aria-live="polite" aria-label="Loading">
    <div class="hd-logo-spinner">
      <img src="assets/images/vita-logo.png" alt="Loading..." />
    </div>
  </div>

  <!-- Shown next to an add action while the health profile (height, weight, blood group) is still incomplete -->
  <div class="hd-ptip" *ngIf="profileTip" role="alert"
       [class.hd-ptip--above]="profileTip.bottom !== null"
       [style.left.px]="profileTip.left" [style.width.px]="profileTip.width"
       [style.top.px]="profileTip.top" [style.bottom.px]="profileTip.bottom"
       [style.--hd-ptip-arrow]="profileTip.arrow + 'px'">
    <button type="button" class="hd-ptip-close" aria-label="Dismiss" (click)="hideProfileTip()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
    </button>
    <div class="hd-ptip-row">
      <span class="hd-ptip-ico" aria-hidden="true">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5h.01"/></svg>
      </span>
      <div class="hd-ptip-text">
        <strong>Complete your health profile first</strong>
        <span>Add your height, weight, blood group, gender and ethnicity to start adding records.</span>
      </div>
    </div>
    <button type="button" class="hd-ptip-btn" (click)="completeProfileFromTip()">Complete profile</button>
  </div>
</div>
<div class="health-container" *ngIf="showCarePlan">
      <app-care-plan></app-care-plan>
      <button (click)="backToHealth()">← Back</button>
</div>
<!-- <div class="health-container" *ngIf="showMedication && medication">
  <app-medication></app-medication>
  <button class="back-button" >← Back to Health</button>
</div> -->